import { Component, OnInit, OnDestroy } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { startWith, map, takeUntil } from 'rxjs/operators';
import { PlanosService } from './planos.service';
import { LoaderService } from 'src/app/loader/loader.service';
import * as moment from 'moment';
import { PermissionsService } from 'src/app/services/permissions.service';

@Component({
  selector: 'app-planos',
  templateUrl: './planos.component.html',
  styleUrls: ['./planos.component.scss'],
})
export class PlanosComponent implements OnInit, OnDestroy {
  env;
  planos: Plano[];
  planos$: Observable<Plano[]>;

  page = 1;
  pageSize = 10;
  collectionSize = 0;
  filter = new FormControl('');

  private unsubscribe$ = new Subject();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private planosService: PlanosService,
    private loaderService: LoaderService,
    public permissionsService: PermissionsService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.route.params.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      if (this.permissionsService.isPermitted('settings')) {
        this.getPlanos(this.env.selected.cnpj);
      } else {
        this.router.navigateByUrl(`/dash/${params.cnpj}`);
      }
    });
  }

  async getPlanos(cnpj: string) {
    const loader = await this.loaderService.notifica({
      title: 'Buscando planos...',
      date: moment().toISOString(),
      type: 'loading',
    });

    this.planos = await this.planosService.getPlanos(cnpj).toPromise();

    this.planos$ = this.filter.valueChanges.pipe(
      startWith(''),
      map(text => this.search(text))
    );

    loader.dismiss();
  }

  search(text: string): Plano[] {
    const planosFiltered: Plano[] = this.planos.filter(plano => {
      const term = text.toLowerCase();
      return (
        plano.descricao.toLowerCase().includes(term) ||
        plano.codigo.toLowerCase().includes(term) ||
        plano.chave_tabela.substring(14, 17).toLowerCase().includes(term)
      );
    });

    this.page = 1;
    this.collectionSize = planosFiltered.length;

    return planosFiltered;
  }

  goBack(): void {
    this.router.navigateByUrl(`/settings/${this.env.selected.cnpj}`);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
